import { useData } from "./useData";

export function useDataWithoutLoading<T>(getData: (as: AbortSignal) => Promise<T>, deps: any[] = [], { historyStateKey, enabled }: { historyStateKey?: string, enabled?: boolean } = {}) {
  return useData(getData, deps, {
    historyStateKey,
    showLoading: "never",
    enabled,
  });
}
